import { render, staticRenderFns } from "./MobileUsageGuideLayer.vue?vue&type=template&id=38856e5a&scoped=true&"
import script from "./MobileUsageGuideLayer.vue?vue&type=script&lang=js&"
export * from "./MobileUsageGuideLayer.vue?vue&type=script&lang=js&"
import style0 from "./MobileUsageGuideLayer.vue?vue&type=style&index=0&id=38856e5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38856e5a",
  null
  
)

export default component.exports